import styled from "styled-components";
import DateDisplay from "../../../components/DateDisplay";
import { CurrencyInput } from "../../../components/forms";

const StyledCell = styled.td`
    vertical-align: middle;
    text-align: ${props => props.textAlign ?? "left"};
    width: ${props => props.width}%;
    max-width: 0;
`;

const ClientApplicationsGridTableRow = ({ data: results, index, style }) => {
    const { height } = style;

    // do not return a data row when the data has not yet been collected from the backend
    if (index >= results.length) {
        return null;
    }

    const {
        applicationId,
        applicationStatusText,
        applicationStatusDate,
        designationName,
        providerName,
        providerReference,
        amount,
        description,
        businessSheetReference,
        instructionSequence,
        applicationSequence,
        adviserName
    } = results[index] || {};


    return <tr>
        <StyledCell className="text-truncate" width={7.5} style={{ height }}>
            {applicationStatusText}
        </StyledCell>
        <StyledCell className="text-truncate" width={7.5} style={{ height }}>
            <DateDisplay className="ms-1 d-none d-xxl-inline" format="DD/MM/YYYY">{applicationStatusDate}</DateDisplay>
        </StyledCell>
        <StyledCell className="text-truncate" width={12}>{designationName}</StyledCell>
        <StyledCell className="text-truncate" width={7.5}>{adviserName}</StyledCell>
        <StyledCell className="text-truncate" width={7.5}>{providerName}</StyledCell>
        <StyledCell className="text-truncate" width={6}>{providerReference}</StyledCell>
        <StyledCell className="text-truncate" width={6}>
            <CurrencyInput displayType={"text"} value={amount} />
        </StyledCell>
        <StyledCell className="text-truncate" width={12.5}>{description}</StyledCell>
    </tr>;
};

export default ClientApplicationsGridTableRow;